import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { translate } from '../Services/translation';
import { getProducts } from '../Services/ShoppingList.service';
import RemoveButton from '../Components/RemoveButton';
import {
  increment,
  decrement,
  setQuantity,
  remove,
} from '../Actions/ShoppingList.action';
import ShoppingListForm from '../Components/ShoppingListForm';

const ShoppingListPage = ({
  title,
  text,
  channelId,
  pageId,
  information,
  tosText
}) => {
  const [orderRows, setOrderRows] = useState([]);
  const dispatch = useDispatch();
  const shoppingList = useSelector((x) => x.shoppingList);
  const showVat = useSelector((state) => state.vat.value);
  const {hidePrices} = window.__litium.channelConfig;
  let totalPrice = 0

  useEffect(() => {
    const setup = async () => {
      if (shoppingList && shoppingList.length > 0) {
        const products = shoppingList.map((x) => x.productId).join(',');
        setOrderRows(await getProducts(products, channelId));
      }
    };
    setup();
  }, []);

  const onPrint = () => {
    window.print();
  };

  const getQuantity = (shoppingList, rowId) => {
    return shoppingList.find((x) => x.productId == rowId).quantity
  }

  const formatPrice = (quantity, row, totalPrice=0) => {
    let price = !totalPrice ? quantity * (showVat ? row.priceWithVAT : row.price) : totalPrice;

    let formatPrice = new Intl.NumberFormat(window.__litium.constants.currentLocale, { 
      style: 'currency', 
      currency: window.__litium.constants.currentCurrency,
      currencyDisplay: 'code',
      maximumFractionDigits: row.currencyFormat.includes('C0') ? 0 : 2,
    });
    let formatted = formatPrice.format(price).replace(window.__litium.constants.currentCurrency, '').trim();

    switch (row.currencyPosition) {
      case 1:
        return `${row.currency}${formatted}`;
      case 2:
        return `${row.currency} ${formatted}`;
      case 4:
        return `${formatted}${row.currency}`;
      case 8:
        return `${formatted} ${row.currency}`;
      default:
        return 'N/A';
    }
  };
  if(shoppingList.length && shoppingList.length > 0) {
    const filteredOrderRows = orderRows.filter((x) => shoppingList.some((y) => x.id == y.productId))
    filteredOrderRows.forEach((row) => {
      totalPrice += showVat ? row.priceWithVAT * getQuantity(shoppingList, row.id) : row.price * getQuantity(shoppingList, row.id)
    })

  return (
    <>
      <div className="row">
        <div className="small-12">
          <h1 className="text--center">{title}</h1>
          <div
            className="text--center"
            dangerouslySetInnerHTML={{ __html: text }}
          ></div>
          <div className="text--center m-b-15">
            <a className="button__text-button" onClick={onPrint}>
              {translate('checkout.print')}
            </a>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="small-12 simple-table show-for-large">
          <div
            className="row small-unstack no-margin checkout__products--header"
            style={{ justifyContent: 'center' }}
          >
            <div className="columns small-1">#</div>
            <div className={`columns small-12 medium-4 large-${!hidePrices ? "5" : "7"}  model-header`}>
              {translate('shoppinglist.name')}
            </div>
            {!hidePrices && (
            <div className="columns small-3 medium-2 large-2">
              {translate('shoppinglist.price')}
            </div>
            )}
            <div className="columns small-4 medium-2 large-1">
              {translate('shoppinglist.quantity')}
            </div>
            
            <div
              className="columns small-5 medium-3 large-3"
              style={{ textAlign: 'center' }}
            >
              {!hidePrices && (
              translate('shoppinglist.total')
              )}
            </div>

          </div>
          {orderRows
            .filter((x) => shoppingList.some((y) => x.id == y.productId))
            .map((row, index) => (
              <div key={row.id}>
                <div
                  className={
                    row.comment
                      ? 'row small-unstack no-margin align-center'
                      : 'row small-unstack no-margin checkout-cart__row'
                  }
                >
                  <div className="columns small-1 shoppinglist__index">
                    {index + 1}
                  </div>
                  <div  className={`columns small-12 medium-4 large-${!hidePrices ? "5" : "7"} checkout-cart__image-container`}>
                    <div className="checkout-cart__image-wrapper">
                      <img
                        className="checkout-cart__image"
                        src={row.image}
                        alt={row.name}
                      />
                    </div>
                    <div className="checkout-cart__image-info">
                      <a className="product-link" href={row.url}>
                        {row.name}
                      </a>
                      <span className="checkout-cart__brand-name">
                        {row.brand}
                      </span>
                      {row.description && (
                        <span className="checkout-cart__description">
                          {row.description}{row.description.length > 50 ? "..." : ""}
                        </span>
                      )}
                      <span className="checkout-cart__article-number">
                        {translate('cart.articlenumber')} {row.articleNumber}
                      </span>
                    </div>
                  </div>
                  {!hidePrices && (
                    <div className="columns small-3 medium-2 large-2 simple-table__cell--no-break-word checkout-cart__single-prize">
                      {showVat ? row.formattedPriceWithVAT : row.formattedPrice}
                    </div>
                    )}
                  <div className="columns small-2 medium-2 large-1 checkout-cart__quantity">
                    <div className="checkout-cart__quantity">
                      <span
                        className="controller"
                        onClick={() => dispatch(decrement(row.id, 1))}
                      >
                        -
                      </span>
                      <input
                        className="checkout-cart__input"
                        type="number"
                        value={
                          shoppingList.find((x) => x.productId == row.id)
                            .quantity
                        }
                        onChange={(event) =>
                          dispatch(setQuantity(row.id, event.target.value))
                        }
                      />
                      <span
                        className="controller"
                        onClick={() => dispatch(increment(row.id, 1))}
                      >
                        +
                      </span>
                    </div>
                  </div>
                  <div className="checkout-cart__total-price columns small-2 medium-3 large-3 simple-table__cell--no-break-word">
                    {!hidePrices && formatPrice(
                      shoppingList.find((x) => x.productId == row.id).quantity,
                      row
                    )}
                    <RemoveButton onClick={() => dispatch(remove(row.id))} />
                  </div>
                </div>
              </div>
            ))}
            {totalPrice > 0 ? (
            <div className='row small-unstack no-margin'>
            <div className='columns medium-12 text--right shoppinglist__total'>
              <h3>{translate('shoppinglist.sum')}: {formatPrice(0, orderRows[0] ,totalPrice)}</h3>
            </div>
            </div>) : null}
        </div>
        <div className="small-12 simple-table checkout-mobile hide-for-large">
          {orderRows
            .filter((x) => shoppingList.some((y) => x.id == y.productId))
            .map((row) => (
              <Fragment key={row.id}>
                <div className="row small-unstack no-margin checkout-cart__row">
                  <div className="columns small-11 medium-11 checkout-cart__image-container">
                    <div className="checkout-cart__image-wrapper">
                      <div className="checkout-cart__image-wrapper">
                        <img
                          className="checkout-cart__image"
                          src={row.image}
                          alt={row.name}
                        />
                      </div>
                    </div>
                    <div className="checkout-cart__image-info">
                      <a className="product-link" href={row.url}>
                        {row.name}
                      </a>
                      <span className="checkout-cart__brand-name">
                        {row.brand}
                      </span>
                      {row.description && (
                        <span className="checkout-cart__description">
                          {row.description}
                        </span>
                      )}
                      <span className="checkout-cart__article-number">
                        {translate('cart.articlenumber')} {row.articleNumber}
                      </span>
                    </div>
                  </div>
                  <div className="checkout-cart__total-price columns small-1 medium-1 simple-table__cell--no-break-word">
                    <RemoveButton onClick={() => dispatch(remove(row.id))} />
                  </div>
                  <span className="spacer"></span>
                  <div className={!hidePrices? 
                  "columns small-8 medium-8 checkout-cart__quantity price-and-quanntity"
                  :"columns small-12 medium-12 checkout-cart__quantity price-and-quanntity"}
                  >
                    {!hidePrices && (
                    <div className="single-price">
                      <p>{translate('checkout.cart.header.price')}</p>
                      {showVat ? row.formattedPriceWithVAT : row.formattedPrice}
                    </div>
                    )}
                    <div className="checkout-cart__quantity">
                      <span
                        className="controller"
                        onClick={() => dispatch(decrement(row.id, 1))}
                      >
                        -
                      </span>
                      <input
                        className="checkout-cart__input"
                        type="number"
                        value={
                          shoppingList.find((x) => x.productId == row.id)
                            .quantity
                        }
                        onChange={(event) =>
                          dispatch(setQuantity(row.id, event.target.value))
                        }
                      />
                      <span
                        className="controller"
                        onClick={() => dispatch(increment(row.id, 1))}
                      >
                        +
                      </span>
                    </div>
                  </div>
                  {!hidePrices && (
                  <div className="columns small-4 medium-4 text--right">
                    <div className="total-price">
                      <p>{translate('checkout.cart.header.total')}</p>
                      {formatPrice(
                        shoppingList.find((x) => x.productId == row.id).quantity,
                        row
                      )}{' '}
                    </div>
                  </div>
                  )}
                </div>
              </Fragment>
            ))}
            {totalPrice && (<div className="row">
              <div className='columns medium-12 text--right shoppinglist__total'>
              <h3>{translate('shoppinglist.sum')}: {formatPrice(0, orderRows[0] ,totalPrice)}</h3>
            </div>
            
            </div>)}
        </div>
      </div>
      <ShoppingListForm
              channelId={channelId}
              pageId={pageId}
              information={information}
              tosText={tosText}
              accessGroups={orderRows.filter((x) => shoppingList.some((y) => x.id == y.productId)).map((x) => x.portalAccessGroup).filter((x, i, a) => a.indexOf(x) === i)}
              totalPrice={totalPrice}
      ></ShoppingListForm>
    </>
      );}
    else {
      return <div>{translate('wishlist.noitems')}</div>;
    }

};

export default ShoppingListPage;
